import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InputByClassTab from './InputByClassTab';
import ButtonGroup from '@mui/material/ButtonGroup';
import InputBySTudentTab from './InputBySTudentTab';

const SpedTab = () => {
  const tabs = [
    {
      key: 'student',
      label: 'Input by Student',
      component: <InputBySTudentTab />,
    },
    {
      key: 'class',
      label: 'Input by Class',
      component: <InputByClassTab />,
    },
  ];

  const [selected, setSelected] = useState(tabs[0].key);

  return (
    <Box>
      <Box display="flex" justifyContent="left" mt={2} mb={3} ml={4}>
        <ButtonGroup
          disableElevation
          sx={{
            borderRadius: '8px',
            overflow: 'hidden',
            boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
            border: '1px solid #e0e0e0',
            backgroundColor: '#f8f9fa',
            flexWrap: 'wrap',
            '& .MuiButton-root': {
              border: 'none',
              borderRight: '1px solid #880d0dff',
              '&:last-child': {
                borderRight: 'none',
              },
            },
          }}
        >
          {tabs.map((tab) => (
            <Button
              key={tab.key}
              disableRipple
              onClick={() => setSelected(tab.key)}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '14px',
                px: 4,
                py: 1.5,

                // Default state (unselected)
                backgroundColor: 'transparent',
                color: '#6c757d',
                border: 'none',

                // Selected state
                ...(selected === tab.key && {
                  border: '1px solid #0066cc !important',
                  backgroundColor: 'rgba(0, 102, 204, 0.1)',
                  color: '#0066cc',
                }),

                // Hover state for all buttons
                '&:hover': {
                  color: '#0066cc',
                  borderColor: '#0066cc',
                  backgroundColor:
                    selected === tab.key
                      ? 'rgba(0, 102, 204, 0.1)'
                      : 'transparent',

                  // Apply border on hover for all buttons
                  border: '1px solid #0066cc !important',
                },

                // Remove MUI focus ring
                '&::after': {
                  display: 'none',
                },

                // Focus state
                '&:focus': {
                  outline: 'none',
                  boxShadow: 'none',
                },

                // Active state
                '&:active': {
                  outline: 'none',
                  boxShadow: 'none',
                },
              }}
            >
              {tab.label}
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      {tabs.find((tab) => tab.key === selected)?.component}
    </Box>
  );
};

export default SpedTab;
